import React from "react";
import { withApollo } from "@apollo/client/react/hoc";
import { Platform, StyleSheet, View } from "react-native";
import FAGridView from "screens/LoginRegistration/components/FAComponent/FAGridView";
import FAListView from "screens/LoginRegistration/components/FAComponent/FAListView";
import { onSubmitMutationHandler } from "screens/LoginRegistration/components/FAComponent/utils";
import { LIST_FUNCTIONAL_AREAS } from "screens/Profile/queries";
import SButton from "styled42/components/SButton";
import SLoader from "styled42/components/SLoader";
import SSnackbar, { LENGTH_LONG } from "styled42/components/SSnackbar";
import { Colors } from "styled42/config";
import {
  pushClevertapEvent,
  pushClevertapProfile
} from "utils/clevertapEvents";
import getData from "utils/getData";
import { sendEventToGA } from "utils/googleAnalyticsEvents";
import { clientHelper } from "utils/graphQL";
import Check from "icons/Check";
import {
  retrieveDataFromAsyncStorage,
  removeDataFromAsyncStorage
} from "screens/common/utils";
import { triggerAdjustRegistrationEvent } from "utils/adjustEvents";
import VernacManager from "utils/vernacular";
import { AuthContext } from "utils/authentication/Auth";

class FAComponent extends React.Component {
  constructor(props) {
    super(props);
    const {
      state: { variant }
    } = props;
    this.state = {
      viewMode: variant === "C" ? "GRID" : "LIST",
      isPageLoading: false,
      isSubmitLoading: false,
      selectedFAList: [],
      fullFAList: [],
      snackbarVisible: false,
      snackbarBackgroundColor: "error",
      snackbarText: "",
      variant
    };
  }

  async componentDidMount() {
    const {
      state: { user, variant },
      client
    } = this.props;

    pushClevertapEvent("Page Load", {
      //Page_Modal: `FA_Select_${variant || "A"}`
      Page_Modal: "FA Select",
      Current_Page: "New loginRegistration",
      Test_Case: variant
    });

    sendEventToGA("Onboarding", "Page Load", "Interested FA Page");

    this.setState({
      isPageLoading: true
    });

    const { data } = await clientHelper("query")(client)({
      query: LIST_FUNCTIONAL_AREAS
    });

    const faArray = getData(user, "stakeholder.functional_areas", []);
    const fullFAList = getData(data, "listFunctionalAreas.edges", []);
    const selectedFAList = [];

    for (let i = 0; i < faArray.length; i += 1) {
      const item = faArray[i];
      selectedFAList.push({
        id: item.id,
        name: item.name
      });
    }

    this.setState({
      isPageLoading: false,
      selectedFAList,
      fullFAList
    });
  }

  signIn = (tokenObj) => {
    const { signIn } = this.context;
    if (Platform.OS === "android") {
      signIn(tokenObj);
    }
  };

  onViewModeChange = (mode) => {
    this.setState({
      viewMode: mode
    });
  };

  hideSnackbar = () => {
    this.setState({
      snackbarVisible: false
    });
  };

  onFASelectHandler = (fa, selected, key) => {
    const { selectedFAList } = this.state;
    const {
      state: { variant }
    } = this.props;
    if (selected) {
      const foundIndex = selectedFAList.findIndex((item) => item.id === fa.id);
      this.onFADeleteHandler(foundIndex);
    } else {
      // const keyToclevertapTypeMapping = {
      //   "popular-list": "FA Selected",
      //   "popular-grid": "FA Selected",
      //   "other-list": "FA Selected - Pop-up",
      //   "search-list": "FA Selected - Pop-up"
      // };
      // pushClevertapEvent(`loginRegister Clicks_${variant}`, {
      //   Type: keyToclevertapTypeMapping[key]
      // });
      pushClevertapEvent("loginRegister Clicks", {
        Page_Modal: "FA Select",
        Current_Page: "New loginRegistration",
        Test_Case: variant,
        Type: "Job role"
      });

      // Show error if more than 3 categories selected
      if (selectedFAList.length === 3) {
        this.setState({
          snackbarVisible: true,
          snackbarText: VernacManager.translateString(
            "onboarding_upto_3_categories"
          ),
          snackbarBackgroundColor: "#FFA734"
        });
        return;
      }
      if (selectedFAList.length === 0) {
        this.setState({ snackbarVisible: false });
      }
      this.setState({
        selectedFAList: [fa, ...selectedFAList]
      });
    }
  };

  onFADeleteHandler = (faIndex) => {
    const { selectedFAList } = this.state;
    // Show error if all categories deselected
    if (selectedFAList.length === 1) {
      this.setState((prevState) => ({
        selectedFAList: prevState.selectedFAList.filter(
          (item, index) => index !== faIndex
        ),
        snackbarVisible: true,
        snackbarText: VernacManager.translateString(
          "onboarding_select_atleast_category"
        ),
        snackbarBackgroundColor: "#FFA734"
      }));
    } else {
      this.setState((prevState) => ({
        selectedFAList: prevState.selectedFAList.filter(
          (item, index) => index !== faIndex
        ),
        snackbarVisible: false
      }));
    }
  };

  onSubmitHandler = async () => {
    const {
      goNext,
      state: { user, variant },
      client
    } = this.props;
    const { selectedFAList } = this.state;
    const FANameMapping = {};

    for (let i = 0; i < selectedFAList.length; i += 1) {
      FANameMapping[`Candidate_FA${i + 1}`] = selectedFAList[i].name;
    }

    pushClevertapProfile({
      Identity: user.id,
      ...FANameMapping
    });

    this.setState({
      isSubmitLoading: true
    });

    const { data, error } = await onSubmitMutationHandler({
      selectedFAList,
      user,
      client
    });

    if (error) {
      this.setState({
        isSubmitLoading: false,
        snackbarVisible: true,
        snackbarText: "Something went wrong!",
        snackbarBackgroundColor: "error"
      });
    } else {
      await this.onBoardingCompleted(user, variant);
      this.setState({
        isSubmitLoading: false
      });
      goNext({
        user: data,
        authSignIn: this.signIn
      });
    }
  };

  onBoardingCompleted = async (user, variant) => {
    const onboardStartTimeKey = `onboardStartTime_${user.mobile}`;
    const onboardStartTimeStr = await retrieveDataFromAsyncStorage(
      onboardStartTimeKey
    );
    const onboardEndTime = new Date();
    let timeTaken = 0;
    if (onboardStartTimeStr) {
      await removeDataFromAsyncStorage(onboardStartTimeKey);
      timeTaken = onboardEndTime - new Date(onboardStartTimeStr);
      timeTaken = `${timeTaken / 1000} sec`;
    }

    pushClevertapEvent("loginRegister Clicks", {
      timestamp: onboardEndTime.toString(),
      Time_Taken: timeTaken,
      Page_Modal: "FA Select",
      Current_Page: "New loginRegistration",
      Test_Case: variant,
      Type: "Show Jobs"
    });

    //adjust event for onboarding completion
    if (Platform.OS === "android") {
      triggerAdjustRegistrationEvent("user_id", user.id);
    }
  };

  render() {
    const { goBack } = this.props;
    const {
      viewMode,
      isPageLoading,
      isSubmitLoading,
      selectedFAList,
      fullFAList,
      snackbarVisible,
      snackbarBackgroundColor,
      snackbarText,
      variant
    } = this.state;

    if (isPageLoading) {
      return (
        <View style={styles.loaderContainer}>
          <SLoader color={Colors.Purple[1]} />
        </View>
      );
    }

    const selectedFAIds = selectedFAList.map((item) => item.id);

    return (
      <View style={styles.root}>
        {viewMode === "LIST" ? (
          <FAListView
            selectedFAList={selectedFAList}
            fullFAList={fullFAList}
            selectedFAIds={selectedFAIds}
            goBack={goBack}
            variant={variant}
            onFASelectHandler={this.onFASelectHandler}
            onFADeleteHandler={this.onFADeleteHandler}
            onViewModeChange={this.onViewModeChange}
          />
        ) : (
          <FAGridView
            selectedFAList={selectedFAList}
            fullFAList={fullFAList}
            selectedFAIds={selectedFAIds}
            goBack={goBack}
            variant={variant}
            onFASelectHandler={this.onFASelectHandler}
            onFADeleteHandler={this.onFADeleteHandler}
            onViewModeChange={this.onViewModeChange}
          />
        )}
        <View style={styles.saveContainer}>
          <SButton
            text={VernacManager.translateString("job_interest_show_jobs")}
            prefixIcon={!isSubmitLoading ? Check : null}
            disabled={selectedFAList.length === 0}
            onClick={isSubmitLoading ? null : this.onSubmitHandler}
          >
            {isSubmitLoading ? <SLoader size={28} color="white" /> : null}
          </SButton>
        </View>
        <SSnackbar
          duration={LENGTH_LONG}
          visible={snackbarVisible}
          backgroundColor={snackbarBackgroundColor}
          text={snackbarText}
          onCompletion={this.hideSnackbar}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    position: "relative",
    height: "100%",
    backgroundColor: "transparent"
  },
  loaderContainer: {
    margin: 15,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  saveContainer: {
    width: "100%",
    padding: 16,
    borderColor: "#F2F2F3",
    borderTopWidth: 1
  }
});

FAComponent.contextType = AuthContext;

export default withApollo(FAComponent);
